// extracted by mini-css-extract-plugin
module.exports = {"cards":"cards-module--cards--1tJ3_","link":"cards-module--link--1aiZs"};